import React, { useState, useMemo } from 'react';
import { Box, Typography, CssBaseline } from '@mui/material';
import { flattenLeaseData, groupDataByFactor } from './leaseUtils';
import { FactorButtons } from './FactorButtons';
import { ComparisonTable } from './ComparisonTable';
import LeaseRecordViewModal from '../LeaseRecordViewModal';

import { v4 as uuidv4 } from 'uuid';

// Assume your raw data is imported here
// import { yourRawLeaseData } from './your-data-source';

export const LeaseComparisonPage = ({ leaseDataList }) => {
	const [selectedFactor, setSelectedFactor] = useState('date');
	const [journalData, setJournalData] = useState([]);
	const [showJournalEntryModal, setShowJournalEntryModal] = useState(false);

	const [tableUpperLeftExtraInfo, setTableUpperLeftExtraInfo] = useState({});


	const { groupedData } = useMemo(() => {
		const flatData = flattenLeaseData(leaseDataList);
		const grouped = groupDataByFactor(flatData, selectedFactor);
		return { groupedData: grouped };
	}, [leaseDataList, selectedFactor]);

	// console.log(groupedData, ' groupedData1122');
	const handleFactorChange = (factor) => {
		setSelectedFactor(factor);
	};

	/**
	 * [NEW] Handles the click event on a data row.
	 * For now, it just logs the journal data to the console as requested.
	 * You can replace this with logic to open a modal, navigate, etc.
	 */
	const handleRowClick = (item) => {
		// console.log(item,'item112233');
		setJournalData(item?.journals);
		setShowJournalEntryModal(true);
		setTableUpperLeftExtraInfo({
			leaseId: item?.leaseId,
			leaseTitle: item?.leaseTitle,
			period: item?.period,

		});

	};

	return (
		<>
			<CssBaseline />
			<Box sx={{ p: 3 }}>
				<Typography variant="h4" gutterBottom>
					Lease Comparison
				</Typography>

				<FactorButtons
					selectedFactor={selectedFactor}
					onFactorChange={handleFactorChange}
				/>

				<Box sx={{ mt: 3 }}>
					{/* [MODIFIED] Pass the onRowClick handler to the table */}
					<ComparisonTable
						groupedData={groupedData}
						factor={selectedFactor}
						onRowClick={handleRowClick}
					/>
				</Box>
				<LeaseRecordViewModal
					key={uuidv4()}
					showModal={showJournalEntryModal}
					setShowModal={setShowJournalEntryModal}
					checkResponseData={journalData || []}
					tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}

				/>
			</Box>
		</>
	);
};